import * as React from 'react';
import TextEditor from '../../../components/TextEditor';
import type { PostDraftInterface } from '../../../interfaces/post.interface';
import PostReplyDrafts from '../../../pages/Drafts/PostReplyDrafts';

interface PostReplyDraftsTabProps {
  username: string | undefined;
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  isEditingDraft: boolean;
  postReplyDrafts: PostDraftInterface[];
}

const PostReplyDraftsTab = (props: PostReplyDraftsTabProps) => {
  const {
    username,
    isModalOpen,
    setIsModalOpen,
    id,
    isEditingDraft,
    postReplyDrafts,
  } = props;

  return (
    <>
      <TextEditor
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        userId={id}
        username={username as string}
        isEditing={isEditingDraft as boolean}
      />
      {postReplyDrafts === null || postReplyDrafts === undefined ? (
        <>No Drafts</>
      ) : (
        <PostReplyDrafts postReplyDrafts={postReplyDrafts} />
      )}
    </>
  );
};

export default PostReplyDraftsTab;
